import React, { Component, Fragment } from 'react';
import { postData } from '../../utils/request';
import Loading from '../shared/Loading';
import Button from '../../artzu-ui/src/Button';
import TextField from '../../artzu-ui/src/TextField';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';

const styles = {
  name: {
    verticalAlign: 'top',
    display: 'none',
    margin: 0,
    border: '1 solid black',
    fontSize: "16px",
    fontFamily: "Helvetica Neue",
    padding: "16px",
    color: "#373F4A",
    backgroundColor: "transparent",
    lineHeight: "1.15em",
    placeholderColor: "#000",
    _webkitFontSmoothing: "antialiased",
    _mozOsxFontSmoothing: "grayscale",
  },
  leftCenter: {
    float: 'left',
    textAlign: 'center'
  },
  blockRight: {
    display: 'block',
    float: 'right'
  },
  center: {
    textAlign: 'center'
  }
}

class SquareForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cardBrand: "",
      nonce: undefined,
      googlePay: false,
      applePay: false,
      masterpass: false,
      cardErrors: [],
      loading: true,
      paidAmount: null,
      partial: false,
      partialAmount: null,
      modalMessage: null
    }
    this.requestCardNonce = this.requestCardNonce.bind(this);
  }

  requestCardNonce() {
    this.setState({ loading: true, cardBrand: "" });
    this.paymentForm.requestCardNonce();
  }

  componentDidMount() {
    const config = {
      applicationId: `${process.env.REACT_APP_SQUARE_ID}`,
      locationId: `${process.env.REACT_APP_SQUARE_LOCATION}`,
      inputClass: "sq-input",
      autoBuild: false,
      inputStyles: [
        {
          fontSize: "16px",
          fontFamily: "Helvetica Neue",
          padding: "16px 0",
          color: "#373F4A",
          backgroundColor: "transparent",
          lineHeight: "1.15em",
          placeholderColor: "#747474",
          _webkitFontSmoothing: "antialiased",
          _mozOsxFontSmoothing: "grayscale"
        }
      ],
      cardNumber: {
        elementId: "sq-card-number",
        placeholder: "• • • •  • • • •  • • • •  • • • •"
      },
      cvv: {
        elementId: "sq-cvv",
        placeholder: "CVV"
      },
      expirationDate: {
        elementId: "sq-expiration-date",
        placeholder: "MM/YY"
      },
      postalCode: {
        elementId: "sq-postal-code",
        placeholder: "Zip"
      },
      callbacks: {
        methodsSupported: (methods) => {
          if (methods.googlePay) {
            this.setState({
              googlePay: methods.googlePay
            })
          }
          if (methods.applePay) {
            this.setState({
              applePay: methods.applePay
            })
          }
          if (methods.masterpass) {
            this.setState({
              masterpass: methods.masterpass
            })
          }
          return;
        },
        createPaymentRequest: () => {
          const { amount } = this.props;
          const { partial, partialAmount } = this.state;
          return {
            requestShippingAddress: false,
            requestBillingInfo: true,
            currencyCode: "USD",
            countryCode: "US",
            total: {
              label: "Autzu Drivesharing LLC",
              amount: partial ? partialAmount : amount,
              pending: false
            },
            lineItems: [
              {
                label: "Subtotal",
                amount: partial ? partialAmount : amount,
                pending: false
              }
            ]
          };
        },
        cardNonceResponseReceived: (errors, nonce, cardData) => {
          const { amount } = this.props;
          const { partial, partialAmount } = this.state;
          if (errors) {
            // Log errors from nonce generation to the Javascript console
            // this.setState({ loading: false })
            // console.log("Encountered errors:");
            // errors.forEach(function (error) {
            //   console.log("  " + error.message);
            // });
            this.setState({ cardErrors: errors, loading: false })
            return;
          }
          // this.setState({
          //   nonce: nonce
          // })
          postData('charges', {
            nonce,
            amount: partial ? partialAmount : amount
          })
            .then(res => {
              this.setState({ paidAmount: parseInt(res.amount), loading: false })
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            })
            .catch(err => {
              if (err.status === "failure" && err.error_messages.length > 0) {
                let cardErrors = err.error_messages.map(error => { return { message: error } })
                this.setState({ cardErrors, loading: false })
              } else if (err.status === "success") {
                this.props.onClick();
              }
            });
        },
        unsupportedBrowserDetected: () => {
        },
        inputEventReceived: (inputEvent) => {
          switch (inputEvent.eventType) {
            case "focusClassAdded":
              break;
            case "focusClassRemoved":
              break;
            case "errorClassAdded":
              // document.getElementById("error").innerHTML =
              //   "Please fix card information errors before continuing.";
              break;
            case "errorClassRemoved":
              // document.getElementById("error").style.display = "none";
              break;
            case "cardBrandChanged":
              if (inputEvent.cardBrand !== "unknown") {
                this.setState({
                  cardBrand: inputEvent.cardBrand
                })
              } else {
                this.setState({
                  cardBrand: ""
                })
              }
              break;
            case "postalCodeChanged":
              break;
            default:
              break;
          }
        },
        paymentFormLoaded: () => {
          // this.paymentForm.focus("cardNumber");
        }
      }
    };
    this.paymentForm = new this.props.paymentForm(config);
    this.paymentForm.build();
    this.setState({ loading: false });
  }

  requestFinancing = () => {
    this.setState({ loading: true })
    this.props.client
      .mutate({
        mutation: REQUEST_FINANCING,
        variables: {
          amount: this.props.amount
        }
      })
      .then((res) => {
        this.setState({
          loading: false,
          modalMessage: res.data.requestFinancing.success ? `Your request has been submitted to our team.\nPlease allow 1-2 business days for processing.` : `An error occurred, please try again.`
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          modalMessage: `An error occurred, please try again.`,
        });
      });
  }

  render() {
    const { amount } = this.props;
    const { cardErrors, loading, paidAmount, partial, partialAmount, modalMessage } = this.state;
    return (
      <div className="container square-modal">
        {
          paidAmount ?
            <div style={{width: "100%"}}>
              <p style={{margin: "1em"}}>Payment of ${paidAmount.toFixed(2)} confirmed.</p>
            </div> : modalMessage ? 
            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p style={{ margin: "1em" }}>{modalMessage}</p>
              <Button width="90px" className="button-cancel-card" onClick={this.props.onClick} label="Okay" />
            </div> :
              loading ? <div className="loading-div"><Loading size="3x" /></div> :
            <div id="form-container" className="square-form">
              <div style={{ textAlign: "center" }}>Outstanding balance: <strong>${amount.toFixed(2)}</strong></div>
              <div className="payments__stripe--title" style={{ display: "flex", width: "100%", justifyContent: "center", margin: "0.5em 0" }}>
                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}><strong>Payment Amount: $</strong></div>{partial ?
                  <div style={{ maxWidth: "5em" }}>
                    <TextField
                      width="100%"
                      placeholder={amount.toFixed(2)}
                      value={partialAmount}
                      style={{ textAlign: "right" }}
                      onChange={e => {
                        if (/^[0-9]+(\.[0-9]{1,2})?$/.test(e.target.value) || e.target.value.length === 0) {
                          console.log(/^[0-9]+(\.[0-9]{1,2})?$/.test(e.target.value))
                          this.setState({ partialAmount: e.target.value })
                        }
                      }}
                    />
                  </div>
                  : <div>{amount.toFixed(2)}</div>}
              </div>
              <a href="javascript:void(0)" style={{ textAlign: "center", color: "#414141", fontSize: "12px", marginBottom: "0.5em", textDecoration: "underline" }} onClick={() => this.setState({ partial: !partial, partialAmount: null })}>{partial ? "Cancel" : "Partial Payment"}</a>
              {partial || amount < 1000 ? null : <a href="javascript:void(0)" style={{ textAlign: "center", color: "#414141", fontSize: "12px", textDecoration: "underline" }} onClick={this.requestFinancing}>Request Financing</a>}
              <div id="sq-ccbox">
                {cardErrors.length > 0 || loading ? null :
                  <p className="square-label">
                    <span style={styles.leftCenter}>Enter Card Info Below </span>
                    <span style={styles.blockRight}>
                      {this.state.cardBrand.toUpperCase()}
                    </span>
                  </p>}
                {loading ? <div className="loading-div"><Loading size="3x" /></div> : null}
                <div id="cc-field-wrapper" style={{ display: loading ? "none" : "block" }}>
                  <div id="sq-card-number" style={{ display: loading ? "none" : "block" }}></div>
                  <input type="hidden" id="card-nonce" name="nonce" />
                  <div id="sq-expiration-date" style={{ display: loading ? "none" : "block" }}></div>
                  <div id="sq-cvv" style={{ display: loading ? "none" : "block" }}></div>
                  <div id="sq-postal-code" style={{ display: loading ? "none" : "block" }}></div>
                </div>
              </div>
              {cardErrors.map((e, i) => {
                return <div className="card-error-msg" key={i}>{e.message}</div>
              })}
              <div className="square-buttons">
                <Button padding="0" className="button-cancel-card" onClick={this.props.onClick} label="Cancel" />
                <Button padding="0" className="button-credit-card" onClick={this.requestCardNonce} label="Pay" disabled={loading} />
              </div>
            </div>}
        {/* <p style={styles.center} id="error"></p> */}
      </div>
    )
  }
}

const REQUEST_FINANCING = gql`
  mutation requestFinancing($amount: Float!) {
    requestFinancing(amount: $amount) {
      success
    }
  }
`

export default withApollo(SquareForm);


// WEBPACK FOOTER //
// ./src/components/NewPayments/SquareForm.js